import { render, staticRenderFns } from "./FriendVolunteerSearchResult.vue?vue&type=template&id=e136306a&scoped=true"
import script from "./FriendVolunteerSearchResult.vue?vue&type=script&lang=ts"
export * from "./FriendVolunteerSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./FriendVolunteerSearchResult.vue?vue&type=style&index=0&id=e136306a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e136306a",
  null
  
)

export default component.exports